import {
  Button,
  Col,
  Form,
  InputNumber,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import { InputFields } from "components/common";
import React, { useEffect, useState } from "react";
import { discountsService, servicePackage, technicalService } from "api";
// import "./DiscountsAdd.scss";
import { ReactComponent as RecycleIconSVG } from "assets/images/svg/recycle.svg";
import Notification from "components/common/notification/notification";
//import FormAdd from "./FormAdd/FormAdd";
import { Select } from "antd";
import { formatToCurrencyType } from "helper/common";
import { FIELD_TYPE, tabKeys } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setKM } from "redux/reducer/employee";
import dayjs from "dayjs";
import { setActiveKey } from "redux/reducer/common";
import { RangePickerProps } from "antd/es/date-picker";
import { dataTTAP } from "./config";
const { INPUT, SELECT, NUMBER, NORMAL_CHECKBOX_NONE, TEXT_AREA } = FIELD_TYPE;
const DiscountsAdd = ({ data }) => {
  console.log("🚀 ~ DiscountsAdd ~ data:", data);

  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const cssProps = {
    labelCol: { xs: 8, sm: 8, md: 8, lg: 12, xl: 12 },
    wrapperCol: { xs: 16, sm: 16, md: 12, lg: 12, xl: 12 },
    css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
  };
  const onChange = async (e) => {
    try {
      const isChecked = e.target.checked;

      if (isChecked) {
        const updatedFieldsCV = fieldsTTC.map((field) => {
          if (field.name === "soLanApDung") {
            form.setFieldValue("soLanApDung", "");
            return {
              ...field,
              disable: true,
            };
          } else if (field.name === "soLuotApDungConLai") {
            return {
              ...field,
              disable: true,
            };
          } else {
            return {
              ...field,
              disable: false,
            };
          }
        });
        setFieldsTTC(updatedFieldsCV);
      } else {
        const updatedFieldsCV = fieldsTTC.map((field) => {
          if (field.name === "soLuotApDungConLai") {
            return {
              ...field,
              disable: true,
            };
          } else {
            return {
              ...field,
              disable: false,
            };
          }
        });
        setFieldsTTC(updatedFieldsCV);
      }
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi");
    }
  };

  const dataTTC = [
    {
      type: TEXT_AREA,
      name: "tenChuongTrinh",
      label: "Tên chương trình",
      ...cssProps,
      disable: true,
    },
    {
      type: INPUT,
      name: "maChuongTrinh",
      label: "Mã chương trình",
      ...cssProps,
      disable: true,
    },
    {
      type: NUMBER,
      name: "soLanApDung",
      label: "Số lượng áp dụng",
      ...cssProps,
      disable: true,
    },
    {
      name: "isKhongGioiHan",
      type: NORMAL_CHECKBOX_NONE,
      label: "Không giới hạn",
      onChange: onChange,
      valuePropName: "checked",
      ...cssProps,
      disable: true,
    },
    {
      type: NUMBER,
      name: "soLuotApDungConLai",
      label: "Số lượng áp dụng còn lại",
      ...cssProps,
      disable: true,
    },
    {
      type: TEXT_AREA,
      name: "moTa",
      label: "Mô tả",
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 24, lg: 24, xl: 24 },
      style: { height: "180px" },
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      disable: true,
    },
  ];
  const dataPTKM = [
    {
      type: SELECT,
      name: "type",
      options: [
        { value: 1, label: "Chiết khấu theo giá trị thanh toán" },
        { value: 2, label: "Chiết khấu theo dịch vụ" },
        { value: 3, label: "Ưu đãi dịch vụ theo tổng giá trị thanh toán" },
      ],
      disable: true,
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 24, lg: 24, xl: 24 },
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      onChange: (value: any) => {
        setSelectedOption(value);
      },
    },
  ];
  let status = useAppSelector((state) => state.employeesReducer.status);
  const dispatch = useAppDispatch();
  const [dataSourceService, setDataSourceService] = useState([]);
  const [dataSourceThird, setDataSourceThird] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [selectedOption, setSelectedOption] = useState(1);
  console.log("🚀 ~ DiscountsAdd ~ selectedOption:", selectedOption);
  const [optionsData, setOptionData] = useState(dataPTKM);
  const [fieldsTTC, setFieldsTTC] = useState(dataTTC);
  const [fieldsTTAP, setFieldsTTAP] = useState(dataTTAP);
  useEffect(() => {
    ColumnsService();
    getListGoiDichVu();
  }, []);
  useEffect(() => {
    form.setFieldsValue({
      ...data,
      createdDate: data?.createdDate ? dayjs(data?.createdDate) : null,
      ngayBatDau: data?.ngayBatDau ? dayjs(data?.ngayBatDau) : null,
      ngayKetThuc: data?.ngayKetThuc ? dayjs(data?.ngayKetThuc) : null,
    });
    getDetailsKM(data.id);
  }, [data]);
  const getDetailsKM = async (id) => {
    if (id !== undefined || id !== null) {
      setLoading(true);
      try {
        let keyCounter = 1;
        const res = await discountsService.detailKM(id);
        dispatch(setKM(res));
        setDataSourceService(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setSelectedOption(res?.type);
        setDataSourceThird(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setDataSource(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    } else {
      if (status == true) {
        setLoading(false);
        form.resetFields();
      } else {
        Notification(
          "warning",
          "Tìm kiếm và chọn danh sách ưu đãi để xem chi tiết thông tin"
        );
        setLoading(true);
      }
    }
  };

  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = form.getFieldValue("ngayKetThuc");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = form.getFieldValue("ngayBatDau");
      if (start) {
        return currentDate < start;
      }
    };
    dataTTAP.find((e) => e.name == "ngayBatDau").disabledDate =
      disabledDateStart;
    dataTTAP.find((e) => e.name == "ngayKetThuc").disabledDate =
      disabledDateEnd;
    setFieldsTTAP([...dataTTAP]);
  }, []);

  const handleInputChange = (key, field, value) => {
    if (selectedOption === 1) {
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, [field]: value });
        if (field === "giamGiaToiDa" && value > item.dieuKien) {
          Notification(
            "error",
            "Mức giảm tối đa không được vượt quá Tổng giá trị."
          );
          return; // Prevent further updates if validation fails
        }

        setDataSource(newData);
      }
    } else if (selectedOption === 2) {
      const newData = [...dataSourceService];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, [field]: value });
        setDataSourceService(newData);
      }
    } else if (selectedOption === 3) {
      const newData = [...dataSourceThird];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, [field]: value });
        setDataSourceThird(newData);
      }
    }
  };
  const handleDiscountTypeChange = (key, value) => {
    if (selectedOption === 1) {
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, loaiGiamGia: value });
        setDataSource(newData);
      }
    } else if (selectedOption === 2) {
      const newData = [...dataSourceService];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, loaiGiamGia: value });
        setDataSourceService(newData);
      }
    } else if (selectedOption === 3) {
      const newData = [...dataSourceThird];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, loaiGiamGia: value });
        setDataSourceThird(newData);
      }
    }
  };
  //  console.log(dataSource);

  const columnsValue = [
    {
      title: "Tổng giá trị",
      dataIndex: "dieuKien",
      rules: [{ max: 10, message: "Không được nhập quá 10 số" }],
      render: (text, record) => (
        <InputNumber
          value={text}
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
          disabled
        />
      ),
    },
    {
      title: "Chiết khấu",
      dataIndex: "giamGia",
      render: (text, record) => (
        <Row gutter={8}>
          <Col flex="auto">
            <InputNumber
              value={record.loaiGiamGia === 0 ? text : text}
              style={{ width: "100%" }}
              formatter={
                record.loaiGiamGia === 0 ? formatToCurrencyType : undefined
              }
              parser={
                record.loaiGiamGia === 0
                  ? (value) => value.replace(/\D/g, "")
                  : undefined
              }
              min={record.loaiGiamGia === 1 ? 0 : undefined}
              disabled
              max={record.loaiGiamGia === 1 ? 100 : undefined}
            />
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 1 ? "primary" : "default"}
              className="buttonphantram"
              disabled
            >
              %
            </Button>
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 0 ? "primary" : "default"}
              disabled
              className="buttonphantram"
            >
              đ
            </Button>
          </Col>
        </Row>
      ),
    },
    {
      title: "Mức giảm tối đa",
      dataIndex: "giamGiaToiDa",
      render: (text, record) => {
        const isDisabled = record.loaiGiamGia === 0;
        const value = isDisabled ? 0 : text;

        return (
          <InputNumber
            value={value}
            onChange={(value) =>
              handleInputChange(record.key, "giamGiaToiDa", value)
            }
            style={{ width: "100%" }}
            formatter={formatToCurrencyType}
            parser={(value) => value.replace(/\D/g, "")}
            disabled={isDisabled}
          />
        );
      },
    },
  ];

  const [serviceOptions, setServiceOptions] = useState([]);
  const [goiDichVu, setGoiDichVu] = useState([]);
  const getListGoiDichVu = async () => {
    try {
      const paramss = { page: 1, limit: 1000 };
      const response = await servicePackage.getListServicePackage(paramss);
      // console.log(response);
      const optionss = response.data.map((e) => {
        return { value: e.id, label: e.tenGoiDichVu };
      });
      setGoiDichVu(optionss);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục gói dịch vụ");
    }
  };
  const ColumnsService = async () => {
    try {
      const paramss = { page: 1, limit: 1000 };
      const response = await technicalService.searchListTechnicalService(
        paramss
      );
      const options = response.map((e) => {
        return { value: e.id, label: e.tenDichVu };
      });
      setServiceOptions(options);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  const columnsService = [
    {
      title: "Dịch vụ",
      dataIndex: "dichVuList",
      render: (text, record) => (
        <Select
          value={text}
          disabled
          style={{ width: "100%" }}
          mode="multiple"
          options={serviceOptions}
          showSearch
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
        ></Select>
      ),
      width: "30%",
    },
    {
      title: "Chiết khấu",
      dataIndex: "giamGia",
      render: (text, record) => (
        <Row gutter={8}>
          <Col flex="auto">
            <InputNumber
              value={record.loaiGiamGia === 0 ? text : text}
              disabled
              style={{ width: "100%" }}
              formatter={
                record.loaiGiamGia === 0 ? formatToCurrencyType : undefined
              }
              parser={
                record.loaiGiamGia === 0
                  ? (value) => value.replace(/\D/g, "")
                  : undefined
              }
              min={record.loaiGiamGia === 1 ? 0 : undefined}
              max={record.loaiGiamGia === 1 ? 100 : undefined}
            />
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 1 ? "primary" : "default"}
              disabled
              className="buttonphantram"
            >
              %
            </Button>
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 0 ? "primary" : "default"}
              disabled
              className="buttonphantram"
            >
              đ
            </Button>
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <Form form={form}>
        <div className="discountsAdd">
          <div style={{ width: "100%", display: "flex" }}>
            <div
              className="container"
              style={{ width: "69%", marginRight: "1%" }}
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                <Row style={{ marginTop: "4px" }} justify={"start"}>
                  <Typography.Text strong>Thông tin chung</Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row gutter={[16, 8]}>
                      <InputFields data={fieldsTTC}></InputFields>
                    </Row>
                  </Col>
                </Row>
              </Space>
            </div>
            <div className="container" style={{ width: "30%" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Row style={{ marginTop: "4px" }} justify={"start"}>
                  <Typography.Text strong>Thông tin áp dụng</Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row gutter={[12, 8]}>
                      <InputFields data={fieldsTTAP}></InputFields>
                    </Row>
                  </Col>
                </Row>
              </Space>
            </div>
          </div>
          <div className="container">
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row justify="space-between">
                <Col>
                  <Row style={{ marginTop: "4px" }} justify="start">
                    <Typography.Text strong>Phương thức ưu đãi</Typography.Text>
                  </Row>
                </Col>
              </Row>
              <Row justify="center">
                <InputFields data={optionsData} />
              </Row>
              {selectedOption === 1 && (
                <Row justify="center">
                  <Table
                    bordered
                    dataSource={dataSource}
                    columns={columnsValue}
                    pagination={false}
                  />
                </Row>
              )}
              {selectedOption === 2 && (
                <Row justify="center">
                  <Table
                    bordered
                    dataSource={dataSourceService}
                    columns={columnsService}
                    pagination={false}
                  />
                </Row>
              )}
            </Space>
          </div>
        </div>
      </Form>
    </Spin>
  );
};

export default DiscountsAdd;
